import { render, staticRenderFns } from "./library-index.vue?vue&type=template&id=47bdfb3f&scoped=true"
import script from "./library-index.vue?vue&type=script&lang=js"
export * from "./library-index.vue?vue&type=script&lang=js"
import style0 from "./library-index.vue?vue&type=style&index=0&id=47bdfb3f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdfb3f",
  null
  
)

export default component.exports